// extracted by mini-css-extract-plugin
export default {"deals":"deals__39-EL"};
    if(module.hot) {
      // 1792408383154
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  